import { gql } from '@bariendo/lib/graphql';

export const PRACTITIONER_FRAGMENT = gql`
  fragment PractitionerFragment on Practitioner {
    id
    resourceType
    # Tells a service account (an automated sender) from a teammate: isServiceAccount
    # reads only the system, so the value is not selected.
    identifier {
      system
    }
    name {
      given
      family
    }
    photo {
      url
      contentType
    }
    telecom {
      system
      value
    }
  }
`;

export const PATIENT_FRAGMENT = gql`
  fragment PatientFragment on Patient {
    id
    resourceType
    name {
      given
      family
    }
    photo {
      url
      contentType
    }
    gender
    birthDate
  }
`;

export const ORGANIZATION_FRAGMENT = gql`
  fragment OrganizationFragment on Organization {
    id
    resourceType
    name
  }
`;

export interface OrganizationFragment {
  id: string;
  resourceType: 'Organization';
  name: string;
}

export interface ProfileFragment {
  id: string;
  resourceType: 'Practitioner' | 'Patient';
  identifier?: Array<{ system?: string }>;
  name?: Array<{
    given?: string[];
    family?: string;
  }>;
}

export const CODEABLE_CONCEPT_FRAGMENT = `
  fragment CodeableConceptFragment on CodeableConcept {
    coding {
      system
      code
      display
    }
  }
`;

export interface CodeableConceptFragment {
  coding?: Array<{
    system?: string;
    code?: string;
    display?: string;
  }>;
}

export const EXTENSION_FRAGMENT = `
  fragment ExtensionFragment on Extension {
    url
    valueString
    valueReference {
      reference
      display
    }
    valueBoolean
    valueDateTime
    extension {
      url
      valueString
      valueReference {
        reference
        display
      }
      valueBoolean
      valueDateTime
      valueAttachment {
        data
        contentType
      }
    }
  }
`;

export interface ExtensionFragment {
  url?: string;
  valueString?: string;
  valueReference?: {
    reference?: string;
    display?: string;
  };
  valueBoolean?: boolean;
  valueDateTime?: string;
  extension?: ExtensionFragment[];
  valueAttachment?: {
    data?: string;
    contentType?: string;
  };
}

export const ATTACHMENT_FRAGMENT = `
  fragment AttachmentFragment on Attachment {
    id
    url
    title
    contentType
    size
    data
  }
`;

export interface AttachmentFragment {
  id?: string;
  url?: string;
  title?: string;
  contentType?: string;
  size?: number;
  data?: string;
}

export const META_FRAGMENT = `
  fragment MetaFragment on Meta {
    security {
      code
      display
    }
  }
`;

export interface MetaFragment {
  security?: {
    code?: string;
    display?: string;
  };
}

export const LOCATION_FRAGMENT = gql`
  fragment LocationFragment on Location {
    id
    resourceType
    locationName: name
    address {
      line
      city
      state
      postalCode
    }
  }
`;

export interface LocationFragment {
  id: string;
  resourceType: 'Location';
  locationName?: string;
  address?: {
    line?: string[];
    city?: string;
    state?: string;
    postalCode?: string;
  };
}
